import { type Dispatch, type SetStateAction } from 'react';

import { Icon } from '@iconify/react';

import { CtyButton } from '../button/CtyButton';

import type { ContractData } from './claimIntakeUtils';

import {

  PolicyReadOnlySection,

  PreviousClaimsLoader,

  ProductReadOnlySection,

  type PreviousClaimsFetchConfig,

} from './claimIntakeReadOnlySections';

import type { PreviousClaimsState } from './previousClaimsApi';



export function VehicleClaimsTab({

  contract,

  showPreviousClaims = false,

  previousClaims,

  onPreviousClaimsChange,

  previousClaimsFetchConfig,

  onBack,

  onContinue,

}: Readonly<{

  contract: ContractData | null;

  showPreviousClaims?: boolean;

  previousClaims: PreviousClaimsState;

  onPreviousClaimsChange: Dispatch<SetStateAction<PreviousClaimsState>>;

  previousClaimsFetchConfig: PreviousClaimsFetchConfig | null;

  onBack: () => void;

  onContinue: () => void;

}>) {

  return (

    <div className="space-y-4 sm:space-y-6">

      {contract ? (

        <>

          <PolicyReadOnlySection contract={contract} />

          <ProductReadOnlySection contract={contract} />

          {showPreviousClaims && previousClaimsFetchConfig ? (

            <PreviousClaimsLoader

              fetchConfig={previousClaimsFetchConfig}

              state={previousClaims}

              onStateChange={onPreviousClaimsChange}

            />

          ) : null}

        </>

      ) : null}



      <div className="flex flex-wrap items-center justify-between gap-3">

        <CtyButton

          variant="bordered"

          onPress={onBack}

          startContent={<Icon icon="mdi:arrow-left" width={18} />}

          className="font-semibold"

        >

          Back

        </CtyButton>

        <CtyButton

          color="primary"

          onPress={onContinue}

          endContent={<Icon icon="mdi:arrow-right" width={18} />}

          className="font-semibold"

        >

          Continue To Repairs

        </CtyButton>

      </div>

    </div>

  );

}

